// extracted by mini-css-extract-plugin
module.exports = {"productosGrid":"ProductosGrid_productosGrid__2JIeG","productosTools":"ProductosGrid_productosTools__l4R_n"};